export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/apple_pay.dd44359f.svg","height":9,"width":20,"blurWidth":0,"blurHeight":0};